export enum SellerBadgeType {
  ActiveLister = 'ACTIVE_LISTER',
  FastReplier = 'FAST_REPLIER',
  SpeedyShipper = 'SPEEDY_SHIPPING',
}
